var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { html, LitElement, nothing } from 'lit';
import { state } from 'lit/decorators.js';
export default class BaseFeaturedProducts extends LitElement {
    constructor() {
        super(...arguments);
        this.batches = [];
    }
    queryListicleItems() {
        return document.querySelectorAll('listicle-item');
    }
    loadMoreProducts(currentIndex, count) {
        if (this.items) {
            this.batches = [...this.batches, this.items.slice(currentIndex, currentIndex + count)];
        }
    }
    render() {
        const maxItems = 5;
        if (!this.items) {
            this.items = Array.from(this.queryListicleItems());
            this.batches = [this.items.slice(this.currentIndex, maxItems)];
        }
        const itemsLeft = this.items.length - this.batches.length * maxItems;
        return html `<section class="featured-products">
            <h3 class="featured-products--title">Featured Products</h3>
            <div class="featured-products--list">${this.renderList(maxItems, itemsLeft)}</div>
        </section>`;
    }
    renderList(maxItems, itemsLeft) {
        return html `<ul class="featured-products--ul">
            ${this.batches.map((batch, currentIdx) => {
            this.currentIndex = (currentIdx + 1) * maxItems;
            return batch.map((item) => this.renderItem(item));
        })}

            <button
                ?hidden=${itemsLeft <= 0}
                class="featured-products--load-button"
                @click=${() => this.loadMoreProducts(this.currentIndex, maxItems)}
            >
                Load More Products (${itemsLeft})
            </button>
        </ul>`;
    }
    renderImage(itemElement) {
        const image = itemElement.item?.images[0];
        let src = undefined;
        const sourceSet = image?.sourceSet;
        if (sourceSet === undefined && image && image.sizes && typeof image.sizes[1] === 'object') {
            src = image.sizes[1].src;
        }
        if (sourceSet === undefined && src === undefined) {
            return html `<div class="featured-products--list-item-no-image">Image Not Available</div>`;
        }
        return html `<img
            class="featured-products--list-item-image"
            src=${src ?? nothing}
            srcset=${sourceSet ?? nothing}
            width=${70}
            height=${90}>
        </img>`;
    }
}
__decorate([
    state(),
    __metadata("design:type", Array)
], BaseFeaturedProducts.prototype, "batches", void 0);
//# sourceMappingURL=baseFeaturedProducts.js.map